import {CommonModule} from '@angular/common';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthService} from '../../services/auth.service';

export type OnboardingChecklistItem = {
    key: string;
    title: string;
    completed: boolean;
};

export type OnboardingChecklist = {
    status: 'IN_PROGRESS' | 'COMPLETED';
    completed_steps: number;
    total_steps: number;
    completion_percentage: number;
    items: OnboardingChecklistItem[];
};

@Component({
    selector: 'app-organization-onboarding',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './organization-onboarding.component.html',
    styleUrl: './organization-onboarding.component.css',
})
export class OrganizationOnboardingComponent implements OnChanges {
    @Input() organizationId: number | null = null;

    checklist: OnboardingChecklist | null = null;
    loading = false;
    loadError = false;
    readonly isSuperUser: boolean;

    constructor(private apiService: ApiService, authService: AuthService) {
        this.isSuperUser = authService.isSuperUser();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['organizationId']) {
            this.loadChecklist();
        }
    }

    get statusLabel(): string {
        return this.checklist?.status === 'COMPLETED' ? 'Completed' : 'In Progress';
    }

    get statusIcon(): string {
        return this.checklist?.status === 'COMPLETED' ? '🟢' : '🟡';
    }

    getItemIcon(completed: boolean): string {
        return completed ? '🟢' : '🟡';
    }

    private loadChecklist(): void {
        if (!this.isSuperUser || !this.organizationId) {
            this.checklist = null;
            return;
        }

        this.loading = true;
        this.loadError = false;
        this.apiService.getOrganizationOnboardingChecklist(Number(this.organizationId)).subscribe({
            next: (response: OnboardingChecklist) => {
                this.checklist = response;
                this.loading = false;
            },
            error: () => {
                this.checklist = null;
                this.loading = false;
                this.loadError = true;
            },
        });
    }
}
